import Cookies from "universal-cookie";

const STORAGE_KEY = "gonetAdminJwt";

/**
 * Admin uses Bearer tokens on API requests. The server also sets an httpOnly
 * cookie on login, which JavaScript cannot read — so we persist the token from
 * the JSON body here for loaders and axios headers.
 */
export function getAuthToken() {
  if (typeof window === "undefined") return undefined;
  try {
    const t = sessionStorage.getItem(STORAGE_KEY);
    if (t) return t;
  } catch {
    /* private mode, etc. */
  }
  const cookies = new Cookies();
  return cookies.get("jwt") || undefined;
}

export function setAuthToken(token) {
  if (typeof window === "undefined" || !token) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* ignore */
  }
  const cookies = new Cookies();
  cookies.set("jwt", token, { path: "/", sameSite: "lax" });
}

export function clearAuthToken() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  const cookies = new Cookies();
  cookies.remove("jwt", { path: "/" });
}
